import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../components/HomeComponent.vue'
import PortfolioPage from '../components/PortfolioPage.vue'
import WerkwijzePage from '../components/WerkwijzePage.vue'

const routes = [
    { path: '/', component: HomePage },
    { path: '/portfolio', component: PortfolioPage },
    { path: '/werkwijze', component: WerkwijzePage },
    { path: '/:pathMatch(.*)*', redirect: '/' },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        }
        if (to.hash) {
            return {
                el: to.hash,
                behavior: 'smooth',
                top: 70, // offset voor vaste navbar
            }
        }
        return { top: 0, behavior: 'smooth' }
    },
})

export default router
